<template>
  <span>
    <v-container v-if="isLoggedIn">
      <DisplayHeader/>
    </v-container>

    <v-container v-if="isLoggedIn">
      <DisplaySidebar/>
    </v-container>
  </span>
</template>

<script>
import DisplayHeader from '@/modules/display/components/Header/DisplayHeader';
import DisplaySidebar from '@/modules/display/components/Sidebar/DisplaySidebar';
import {mapGetters} from 'vuex';

export default {
  name: 'DisplayModule',
  components: {
    DisplayHeader,
    DisplaySidebar
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  }
};
</script>
